// Bilingual pricing catalogue (USD). Each text field is { en, es }.
const L = (en, es) => ({ en, es });

export const pricingGroups = [
  {
    id: 'websites',
    title: L('Professional Website Packages', 'Paquetes Profesionales de Sitios Web'),
    subtitle: L('Designed for visibility. Built for your growth.', 'Diseñados para darte visibilidad. Creados para tu crecimiento.'),
    packs: [
      {
        name: L('Professional Website', 'Sitio Web Profesional'), price: 1499,
        desc: L('Everything you need for a strong, professional online presence.', 'Todo lo necesario para una presencia en línea sólida y profesional.'),
        features: [
          L('Professional website design', 'Diseño de sitio web profesional'),
          L('Menu or services section', 'Sección de menú o servicios'),
          L('Geolocation (Google Maps)', 'Geolocalización (Google Maps)'),
          L('SEO & GEO implementation', 'Implementación SEO y GEO'),
          L('WhatsApp & social media integration', 'Integración con WhatsApp y redes sociales')
        ]
      },
      {
        name: L('3D / Semi-3D Homepage', 'Página de Inicio 3D / Semi 3D'), price: 2499, popular: true,
        desc: L('Everything in Professional Website, plus:', 'Todo lo del Sitio Web Profesional, más:'),
        features: [
          L('Modern, immersive 3D or Semi-3D homepage', 'Página de inicio 3D o Semi 3D moderna e inmersiva'),
          L('Featured customer reviews to build trust', 'Reseñas de clientes destacadas para generar confianza'),
          L('Custom offers & promotions', 'Ofertas y promociones personalizadas')
        ]
      },
      {
        name: L('Premium Business Package', 'Paquete Empresarial Premium'), price: 4999,
        desc: L('Everything in 3D Homepage, plus:', 'Todo lo de la Página de Inicio 3D, más:'),
        features: [
          L('2 months of free priority technical support', '2 meses gratis de soporte técnico prioritario'),
          L('Ongoing guidance to help your business grow', 'Orientación continua para hacer crecer tu negocio')
        ]
      }
    ]
  },
  {
    id: 'ai-web',
    title: L('Smart Web Solutions for Great Visionaries', 'Soluciones Web Inteligentes para Grandes Visionarios'),
    subtitle: L('AI-powered websites and landing pages. Advanced technology, exceptional design, real results.', 'Sitios web y landing pages con IA. Tecnología avanzada, diseño excepcional, resultados reales.'),
    packs: [
      {
        name: L('Smart Site Essential', 'Smart Site Esencial'), tagline: L('Build your smart presence', 'Crea tu presencia inteligente'), price: 15000,
        desc: L('A high-end website or landing page with built-in AI.', 'Sitio web o landing page de alto nivel con IA integrada.'),
        features: [
          L('Premium custom web design', 'Diseño web premium y personalizado'),
          L('Integrated Artificial Intelligence', 'Inteligencia Artificial integrada'),
          L('Full admin panel', 'Panel de administración completo'),
          L('Services section or landing page', 'Sección de servicios o landing page'),
          L('Geolocation, SEO & GEO', 'Geolocalización, SEO y GEO'),
          L('WhatsApp & social media integration', 'Integración con WhatsApp y redes sociales'),
          L('Smart forms & automation', 'Formularios inteligentes y automatización'),
          L('Domain, hosting & SSL included', 'Dominio, hosting y SSL incluidos'),
          L('6 months support + team training', 'Soporte 6 meses + capacitación del equipo')
        ]
      },
      {
        name: L('Smart Site Advanced', 'Smart Site Avanzado'), tagline: L('Scale with intelligence', 'Escala con inteligencia'), price: 30000, popular: true,
        desc: L('Everything in Smart Site Essential, plus:', 'Todo lo de Smart Site Esencial, más:'),
        features: [
          L('Advanced interactive UX/UI', 'Diseño UX/UI avanzado e interactivo'),
          L('Custom AI agents', 'Agentes de IA personalizados'),
          L('Automations & workflows', 'Automatizaciones y flujos de trabajo'),
          L('CRM & external tool integration', 'Integración con CRM y herramientas externas'),
          L('Advanced real-time analytics', 'Analítica avanzada en tiempo real'),
          L('Memberships or client area', 'Membresías o área de clientes'),
          L('Multi-language & multi-market', 'Multilenguaje y multi-mercado'),
          L('Conversion optimization (CRO)', 'Optimización de conversión (CRO)'),
          L('12 months support + strategy consulting', 'Soporte 12 meses + consultoría estratégica')
        ]
      },
      {
        name: L('Smart Site Elite', 'Smart Site Élite'), tagline: L('No limits for your vision', 'Sin límites para tu visión'), price: 50000,
        desc: L('Everything in Smart Site Advanced, plus:', 'Todo lo de Smart Site Avanzado, más:'),
        features: [
          L('Custom digital strategy', 'Estrategia digital personalizada'),
          L('Custom-built features', 'Funcionalidades a medida'),
          L('API & enterprise system integration', 'Integración con APIs y sistemas empresariales'),
          L('Advanced generative AI', 'IA generativa avanzada'),
          L('Custom analytics dashboard', 'Dashboard analítico personalizado'),
          L('Advanced security & backups', 'Seguridad avanzada y copias de seguridad'),
          L('Cloud Enterprise scalability', 'Escalabilidad Cloud Enterprise'),
          L('24 months priority support', 'Soporte prioritario 24 meses'),
          L('Dedicated team & ongoing updates', 'Equipo dedicado y actualizaciones continuas')
        ]
      }
    ]
  },
  {
    id: 'custom-ai',
    title: L('Smart Web Solutions for a New Business Era', 'Soluciones Web Inteligentes para una Nueva Era de Negocios'),
    subtitle: L('Websites and landing pages with your own custom-trained AI.', 'Sitios web y landing pages con IA personalizada.'),
    packs: [
      {
        name: L('AI Platform Foundation', 'Plataforma IA Base'), tagline: L('A solid foundation for big ideas', 'Base sólida para grandes ideas'), price: 30000,
        desc: L('Focused on intelligence, presence and growth.', 'Enfocado en inteligencia, presencia y crecimiento.'),
        features: [
          L('Custom website or landing page', 'Sitio web o landing page personalizado'),
          L('Custom AI built on your own data (fine-tuned models or retrieval-augmented generation)', 'IA personalizada basada en tus datos (modelos ajustados o generación aumentada por recuperación)'),
          L('Full admin panel', 'Panel de administración completo'),
          L('Premium custom UX/UI', 'Diseño UX/UI premium a medida'),
          L('Advanced SEO & GEO + geolocation', 'SEO y GEO avanzado + geolocalización'),
          L('WhatsApp, social media & CRM integration', 'Integración con WhatsApp, redes y CRM'),
          L('Automations & workflows', 'Automatizaciones y flujos de trabajo'),
          L('Domain, hosting & SSL included', 'Dominio, hosting y SSL incluidos'),
          L('12 months support + team training', 'Soporte 12 meses + capacitación del equipo')
        ]
      },
      {
        name: L('AI Platform Growth', 'Plataforma IA Crecimiento'), tagline: L('More capacity, more possibilities', 'Más capacidad, más posibilidades'), price: 50000, popular: true,
        desc: L('Scale your business with AI. Everything in AI Platform Foundation, plus:', 'Escala tu negocio con IA. Todo lo de Plataforma IA Base, más:'),
        features: [
          L('Advanced custom AI trained and grounded on your data', 'IA personalizada avanzada entrenada y fundamentada en tus datos'),
          L('Custom AI agents (sales, support, marketing, analytics)', 'Agentes de IA (ventas, soporte, marketing, análisis)'),
          L('API & external system integration', 'Integración con APIs y sistemas externos'),
          L('Multi-language & multi-market', 'Multilenguaje y multi-mercado'),
          L('Advanced real-time analytics', 'Analítica avanzada en tiempo real'),
          L('Memberships or client area', 'Membresías o área de clientes'),
          L('Business process automation', 'Automatización de procesos empresariales'),
          L('E-commerce or custom features', 'E-commerce o funcionalidades a medida'),
          L('CRO, continuous testing & tuning', 'CRO, pruebas y ajustes continuos'),
          L('18 months support + strategy consulting', 'Soporte 18 meses + consultoría estratégica')
        ]
      },
      {
        name: L('AI Platform Enterprise', 'Plataforma IA Empresarial'), tagline: L('A unique platform. Your own AI.', 'Una plataforma única. Tu propia IA.'), price: 80000,
        desc: L('Everything in AI Platform Growth, plus:', 'Todo lo de Plataforma IA Crecimiento, más:'),
        features: [
          L('Complete, scalable enterprise web platform', 'Plataforma web empresarial completa y escalable'),
          L('Enterprise-grade AI with multiple specialized agents, grounded on your data', 'IA empresarial con múltiples agentes especializados, fundamentada en tus datos'),
          L('Complex enterprise integrations', 'Integraciones complejas con sistemas empresariales'),
          L('Advanced real-time BI dashboard', 'Dashboard BI avanzado en tiempo real'),
          L('Cloud Enterprise, security & backups', 'Cloud Enterprise, seguridad y respaldos'),
          L('High-performance scalable architecture', 'Arquitectura escalable de alto rendimiento'),
          L('24 months priority support', 'Soporte prioritario 24 meses'),
          L('Dedicated team & ongoing updates', 'Equipo dedicado y actualizaciones continuas')
        ]
      }
    ]
  },
  {
    id: 'custom-tech',
    title: L('Tailor-Made Technology Services', 'Servicios de Tecnología a tu Medida'),
    subtitle: L('Smart solutions for companies that want to lead.', 'Soluciones inteligentes para empresas que quieren liderar.'),
    from: true,
    packs: [
      {
        name: L('Custom AI Development', 'Desarrollo de IA Personalizada'), price: 2999,
        desc: L('AI solutions that automate processes, analyze data and improve decisions.', 'Soluciones de IA que automatizan procesos, analizan datos y mejoran decisiones.'),
        features: [
          L('Intelligent process automation', 'Automatización de procesos inteligentes'),
          L('Custom AI models with your data', 'Modelos de IA con tus datos'),
          L('Integration with existing systems', 'Integración con sistemas existentes'),
          L('Virtual assistants & smart chatbots', 'Asistentes virtuales y chatbots inteligentes'),
          L('Predictive analytics & insights', 'Análisis predictivo e insights')
        ]
      },
      {
        name: L('Mobile Apps (Android & iOS)', 'Apps Móviles (Android e iOS)'), price: 4999, popular: true,
        desc: L('Native or cross-platform iOS & Android apps — we recommend the best fit for your product.', 'Apps iOS y Android nativas o multiplataforma: te recomendamos la mejor opción para tu producto.'),
        features: [
          L('Native or cross-platform iOS & Android apps', 'Apps iOS y Android nativas o multiplataforma'),
          L('Modern UI/UX design', 'Diseño UI/UX moderno'),
          L('Performance optimization', 'Alto rendimiento y optimización'),
          L('API & external service integration', 'Integración con APIs y servicios externos'),
          L('Google Play & App Store publishing', 'Publicación en Google Play y App Store'),
          L('Ongoing support & maintenance', 'Soporte y mantenimiento continuo')
        ]
      },
      {
        name: L('Enterprise Platforms & Management Systems', 'Plataformas Empresariales y Sistemas de Gestión'), price: 9999,
        desc: L('Robust, scalable systems that centralize operations and drive growth.', 'Sistemas robustos y escalables que centralizan operaciones e impulsan el crecimiento.'),
        features: [
          L('Scalable custom systems', 'Sistemas escalables y personalizados'),
          L('Advanced admin panels', 'Paneles de administración avanzados'),
          L('User & permission management', 'Gestión de usuarios y permisos'),
          L('Real-time reports & analytics', 'Reportes y análisis en tiempo real'),
          L('Third-party integrations', 'Integración con herramientas de terceros'),
          L('Data security & backups', 'Seguridad de datos y respaldos')
        ]
      }
    ]
  }
];

export const addons = {
  title: L('Additional Services', 'Servicios Adicionales'),
  subtitle: L('Complementary solutions, extraordinary results.', 'Soluciones complementarias, resultados extraordinarios.'),
  items: [
    { name: L('Social Media Management', 'Gestión de Redes Sociales'), price: 499, desc: L('Grow your presence, engagement and audience connection.', 'Aumenta tu presencia, interacción y conexión con tu audiencia.') },
    { name: L('Logo & Brand Design', 'Diseño de Logo y Marca'), price: 1999, desc: L('Unique, professional visual identities that capture your brand.', 'Identidades visuales únicas que representan la esencia de tu marca.') },
    { name: L('Marketing Campaigns', 'Campañas de Marketing'), price: 799, desc: L('Strategic campaigns that generate leads and increase sales.', 'Campañas estratégicas para generar clientes y aumentar ventas.') },
    { name: L('Sales Funnels', 'Embudos de Ventas'), price: 999, desc: L('Funnels for sales, followers, visibility and viral content.', 'Embudos para ventas, seguidores, visibilidad y contenido viral.') },
    { name: L('Platform & Business Automation', 'Automatización de Plataformas y Negocios'), price: 399, desc: L('Save time, reduce errors and scale smartly.', 'Ahorra tiempo, reduce errores y escala de forma inteligente.') },
    { name: L('Technical Support', 'Soporte Técnico'), price: 199, desc: L('Fast, reliable help so your business never stops.', 'Asistencia rápida y confiable para que tu negocio nunca se detenga.') }
  ]
};

export const ui = {
  eyebrow: L('Pricing', 'Precios'),
  h1: L('Services & Pricing', 'Servicios y Tarifas'),
  intro: L('Clear packages in USD. Pick the one that fits your goals, or contact us for a custom quote.', 'Paquetes claros en USD. Elige el que se ajuste a tus objetivos o contáctanos para una cotización a medida.'),
  from: L('From', 'Desde'),
  popular: L('Most popular', 'Más popular'),
  cta: L('Get started', 'Empezar'),
  customTitle: L('Need something custom?', '¿Necesitas algo a medida?'),
  customText: L('Tell us about your project and we will prepare a tailored proposal.', 'Cuéntanos tu proyecto y te prepararemos una propuesta personalizada.'),
  customCta: L('Contact us', 'Contáctanos'),
  note: L('Prices are starting points in USD. Your final quote depends on scope — every proposal is free and without commitment.', 'Los precios son puntos de partida en USD. Tu cotización final depende del alcance; cada propuesta es gratuita y sin compromiso.'),
  unsure: L('Not sure which package fits? Talk to us', '¿No sabes qué paquete elegir? Habla con nosotros'),
  faqTitle: L('FAQ about pricing', 'Preguntas sobre precios')
};

export const pricingFaq = [
  { q: L('What is included in the price?', '¿Qué incluye el precio?'), a: L('Each package lists its included features. Anything outside that list is scoped and quoted separately in your proposal.', 'Cada paquete detalla lo que incluye. Todo lo adicional se define y cotiza por separado en tu propuesta.') },
  { q: L('Can I get a custom quote?', '¿Puedo pedir una cotización a medida?'), a: L('Yes. Tell us about your project and we will prepare a tailored proposal, free and without commitment.', 'Sí. Cuéntanos tu proyecto y te prepararemos una propuesta personalizada, gratuita y sin compromiso.') },
  { q: L('How long does a project take?', '¿Cuánto tarda un proyecto?'), a: L('Timelines depend on scope; we share an estimate in the proposal.', 'Los plazos dependen del alcance; compartimos una estimación en la propuesta.') },
  { q: L('How do payments work?', '¿Cómo funcionan los pagos?'), a: L('Payment terms are agreed in the proposal before work starts.', 'Las condiciones de pago se acuerdan en la propuesta antes de empezar.') }
];

export const fmt = (n) => `$${n.toLocaleString('en-US')}`;